import React, { useState } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import clsx from "classnames";
import styles from "./styles.module.scss";
import { getAsset } from "@/getters/getAsset";

export const TextWithVideo = ({ className, title, content, image, video }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div className={clsx(className, styles.section)}>
      <Container fluid="lg" className="py-5 py-md-6">
        <Row className="align-items-center">
          <Col xs={12} md={6}>
            {title && (
              <h2 className="mb-4" data-sourceflow-prop="title">
                {title}
              </h2>
            )}
            {content && (
              <div
                data-sourceflow-prop="content"
                dangerouslySetInnerHTML={{ __html: content }}
              />
            )}
          </Col>
          <Col xs={12} md={6}>
            <figure className={styles.video} onClick={handleShow}>
              <img
                className="w-100"
                src={image?.url || getAsset({ path: "page.work_for_us.story.image" })}
                alt="Photo of IT Works Health team members"
                data-sourceflow-prop="image"
              />
            </figure>
          </Col>
        </Row>
      </Container>

      <Modal
        className={[styles.modal, show ? styles.show : ""].join(" ")}
        show={show}
        onHide={handleClose}
        centered
        size="lg"
      >
        <Modal.Header closeButton />
        <Modal.Body>
          <iframe
            frameBorder="0"
            scrolling="no"
            marginHeight="0"
            marginWidth="0"
            width="800"
            height="443"
            type="text/html"
            src={video}
            data-sourceflow-prop="video"
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default TextWithVideo;
